import {
    MercuryStore,
    MercuryStoreKr,
    MercuryStoreTgt,
    MercuryRetailer,
    isKrogerLocation,
    isTargetLocation,
    isWalmartLocation,
} from '@andromeda/polaris-data-access-products';

export class RetailerLocationAddress {
    public street: string;

    public city: string;

    public state: string;

    public zipCode: string;

    public distance: string;

    constructor(street: string, city: string, state: string, zipCode: string, distance: string) {
        this.street = street || '';
        this.city = city || '';
        this.state = state || '';
        this.zipCode = zipCode || '';
        this.distance = distance || '';
    }
}

export class RetailerLocation {
    public retailer: MercuryRetailer;

    public id: string;

    public accessPointId: string;

    public fulfillmentStoreId: string;

    public chain: string;

    public logo: string;

    public url: string;

    public address: RetailerLocationAddress;

    constructor(
        retailer: MercuryRetailer,
        id: string,
        accessPointId: string,
        fulfillmentStoreId: string,
        chain: string,
        logo: string,
        url: string,
        address: RetailerLocationAddress,
    ) {
        this.retailer = retailer;
        this.id = id;
        this.accessPointId = accessPointId || id;
        this.fulfillmentStoreId = fulfillmentStoreId || id;
        this.chain = chain || '';
        this.logo = logo;
        this.url = url;
        this.address = address;
    }

    public static createDefaultLocation(): RetailerLocation {
        const address = new RetailerLocationAddress('', '', '', '', '');
        return new RetailerLocation(
            MercuryRetailer.AMAZON,
            '',
            '',
            '',
            '',
            '',
            '',
            address,
        );
    }

    public static createFromMecuryStore(store: MercuryStore | MercuryStoreTgt | MercuryStoreKr): RetailerLocation {
        if (isWalmartLocation(store)) {
            const address = new RetailerLocationAddress(store.location.address, store.location.city, store.location.state, store.location.zipCode, store.location.distance);
            return new RetailerLocation(MercuryRetailer.WALMART, store.accessPointId, store.accessPointId, store.fulfillmentStoreId, 'Walmart', 'https://cdn.polaris.me/cva/img/Walmart_Logos_TheSpark_ylw_rgb.png', 'https://www.walmart.com/', address);
        }
        if (isKrogerLocation(store)) {
            const address = new RetailerLocationAddress(store.address.line1, store.address.city, store.address.state, store.address.zipCode, store.address.distance);
            return new RetailerLocation(MercuryRetailer.KROGER, store.locationId, store.locationId, store.locationId, store.chain, store.logo, store.url || 'https://kroger.com', address);
        }
        if (isTargetLocation(store)) {
            const address = new RetailerLocationAddress(store.address.line, store.address.city, store.address.state, store.address.zipCode, store.address.distance);
            return new RetailerLocation(MercuryRetailer.TARGET, store.locationId, store.locationId, store.locationId, 'Target', 'https://cdn.polaris.me/cva/img/target-logo-square.png', 'https://target.com', address);
        }
        return RetailerLocation.createDefaultLocation();
    }
}
